import { SavingLinkList } from '@components/saving-link-list/saving-link-list';

export const OverviewOfSavingInfoPage = () => <SavingLinkList />;
